import React from 'react';
import { Route, Switch } from 'react-router-dom';
import StaffContainer from './staff-container';

function Staff() {
  return (
    <Switch>
      <Route exact path="/staff/:teamId/:season" component={StaffContainer} />
    </Switch>
  );
}

export default Staff;
